import groupingsMixin from '@/mixins/groupings';
import { stripHtml } from '@/utils';

export default {
  mixins: [groupingsMixin],
  data () {
    return {
      activeTabId: null,
      topicsLoading: false,
    };
  },
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    assetTrayGrouping () {
      return this.getAssetTrayGrouping(this.flashcard);
    },
    assetTrayTabs () {
      const assetAssociations = this.assetTrayGrouping?.assetAssociations || [];

      const topicOrderMap = assetAssociations.reduce((acc, aa) => {
        acc[aa.assetBId] = {
          groupingId: aa.assetBId,
          topicId: Number(aa.assetBContext),
          order: aa.order,
        };
        return acc;
      }, {});

      const tabGroupings = assetAssociations
        .map(aa => +aa.assetBId)
        .filter(id => id > 0)
        .map(id => this.$store.getters['groupings/all'][id])
        .sort((a, b) => topicOrderMap[a.id].order - topicOrderMap[b.id].order);

      const topicSets = tabGroupings.map(g => this.getTopics(g).filter(t => t?.content)).filter(ts => ts && ts.length);

      if (topicSets.length > 0) {
        this.activeTabId = this.rootTopics[0]?.id;
      }
      const tabs = topicSets
        .map((topicSet, index) => {
          const subTopics = topicSet
            .map(topic => ({
              id: topic.id,
              title: stripHtml(topic.title),
              content: topic.content,
            }));
          return {
            id: this.rootTopics[index]?.id,
            buttonTitle: stripHtml(this.rootTopics[index]?.title),
            subTopics,
            newContent: assetAssociations[index].displayType === 'new_content',
            order: assetAssociations[index].order,
          };
        });

      if (tabs.length > 0) {
        this.activeTabId = tabs[0].id;
      }
      return tabs;
    },
    rootTopicIds () {
      const rootTopicIds = this.assetTrayGrouping?.assetAssociations
        .map(aa => aa.assetBContext) || [];
      return rootTopicIds;
    },
    rootTopics () {
      const rootTopics = this.rootTopicIds
        .map(id => this.$store.getters['topics/topics'][id])
        .filter(topic => topic).sort((a, b) => a.order - b.order);
      return rootTopics;
    },
    showAssetTray () {
      return this.$store.getters['ui/showAssetTray'];
    },
    firstTabId () {
      return this.assetTrayTabs[0]?.id || null;
    },
  },
  watch: {
    flashcard () {
      this.activeTabId = this.firstTabId;
      this.fetchRootTopics();
    },
    rootTopicIds () {
      this.fetchRootTopics();
    },
  },
  mounted () {
    this.activeTabId = this.firstTabId;
    this.fetchRootTopics();
  },
  methods: {
    fetchRootTopics () {
      if (this.topicsLoading) return;
      if (!this.rootTopicIds || this.rootTopicIds.length === 0) return;

      this.topicsLoading = true;
      this.$store.dispatch('topics/load', { ids: this.rootTopicIds })
        .finally(() => {
          this.topicsLoading = false;
        });
    },
    getTopics (grouping) {
      const assetAssociations = (grouping?.assetAssociations || []).sort((a, b) => a.order - b.order);
      const topicIds = assetAssociations
        .map(aa => +aa.assetBId)
        .filter(id => id > 0);
      return topicIds.map(id => this.$store.getters['topics/topics'][id]);
    },
    toggleAssetTray () {
      this.$store.commit('ui/setShowAssetTray', !this.showAssetTray);
      if (this.showAssetTray) {
        this.$nextTick(() => {
          const el = document.getElementById('asset-tray');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      }
    },
  },
};
